import React from "react";
import { HomepageCallout } from "gatsby-theme-carbon";
import HomepageTemplate from "gatsby-theme-carbon/src/templates/Homepage";
import HomepageVideo from "../../components/HomepageVideo";

const FirstLeftText = () => <p>Welcome</p>;

const FirstRightText = () => (
  <p>
    IBM workplaces foster teaming and collaboration with our clients in our
    technology garages, research labs, data centers and design studios.
    Together, our diverse community inspires a global culture of relentless
    innovation to tackle the biggest challenges facing business today.
  </p>
);

const customProps = {
  Banner: (
    <HomepageVideo
      src="videos/leadspace-video.mp4"
      poster="videos/leadspace-video-poster.jpg"
    />
  ),
  FirstCallout: (
    <HomepageCallout
      backgroundColor="#161616"
      color="white"
      leftText={FirstLeftText}
      rightText={FirstRightText}
    />
  ),
  SecondCallout: null,
};

// spreading the original props gives us props.children (mdx content)
function ShadowedHomepage(props) {
  return <HomepageTemplate {...props} {...customProps} />;
}

export default ShadowedHomepage;
